import FilePreview, { Props as FilePreviewProps } from '@components/FilePreview';
import { FormattedMessage } from 'utils/intl';

import messages from './PdfFilePreview.messages';

type Props = Omit<FilePreviewProps, 'fileType' | 'preview'>;

const PdfFilePreview = ({
  additionalButton,
  classes,
  fileName,
  fileUrl,
  downloadFileName,
  headerComponent,
}: Props): JSX.Element => (
  <FilePreview
    fileType="PDF"
    fileName={fileName}
    fileUrl={fileUrl}
    downloadFileName={downloadFileName}
    classes={classes}
    downloadMessage={<FormattedMessage {...messages.download} />}
    headerComponent={headerComponent}
    additionalButton={additionalButton}
    preview={
      <object type="application/pdf" data={fileUrl} className={classes?.object}>
        <embed type="application/pdf" src={fileUrl} className={classes?.embed} />
      </object>
    }
  />
);

export default PdfFilePreview;
